import React, { useEffect } from "react";
import styles from "../Documents.module.css";
import DocumentUpload from "uicomponents/DocumentUpload";
import TextArea from "uicomponents/TextArea";
import RadioInput from "uicomponents/RadioInput";
import { sectionsQuestions } from "pages/WorkersCompApplcation/utils/sectionsQuestions";
import { WCAppType } from "types";
import { DocumentsFormType } from "../../../utils/formType";
import { useFormikContext } from "formik";
interface IDocumentsComponentProps {
  data?: WCAppType;
  fieldRefs: React.MutableRefObject<{ [key: string]: HTMLInputElement | null }>;
}

const DocumentsComponent = ({
  ...props
}: IDocumentsComponentProps): JSX.Element => {
  const { data, fieldRefs } = props;
  const { values, setFieldValue } = useFormikContext();
  const noRunsReportOtherReasonReqired = (values as DocumentsFormType)
    ?.noLossRunsReportReason;

  const labelList = sectionsQuestions["documents"].questions;
  const messageList = sectionsQuestions["documents"].message;

  useEffect(() => {
    if (noRunsReportOtherReasonReqired !== "Other") {
      setFieldValue("noLossRunsReportOtherReason", "");
    }
  }, [noRunsReportOtherReasonReqired, setFieldValue]);

  return (
    <div>
      <div className={styles.title}>{sectionsQuestions["documents"].title}</div>
      <div className={styles.description}>
        {sectionsQuestions["documents"].description}
      </div>
      <DocumentUpload
        name="incorporationDocuments"
        label={labelList.incorporationDocuments}
        message={messageList.incorporationDocuments}
        application={data}
        fieldRefs={fieldRefs}
      />
      <DocumentUpload
        name="lossRunsReport"
        label={labelList.lossRunsReport}
        message={messageList.lossRunsReport}
        required={false}
        application={data}
      />
      <RadioInput
        name="noLossRunsReportReason"
        label={labelList.noLossRunsReportReason}
        options={[
          "Our company didn’t have previous W-2 employees.",
          "Will send it out when our current carrier provides it",
          "Other",
        ]}
        fieldRefs={fieldRefs}
      />
      {noRunsReportOtherReasonReqired === "Other" && (
        <TextArea
          name="noLossRunsReportOtherReason"
          label={labelList.noLossRunsReportOtherReason}
          fieldRefs={fieldRefs}
        />
      )}
    </div>
  );
};

export default DocumentsComponent;
